import Task from "../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import ScormEvent from "../events/ScormEvent";

export default class InitializeScormTask extends Task {
    constructor(dispatcher) {
        super();

        this._dispatcher = dispatcher;
    }

    execute(callback, progressCallback) {
        this._dispatcher.dispatch(ScormEvent.START_SESSION);

        callback(this);
    }
}